import { ChangeDetectionStrategy, Component, inject, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs/operators';
import { TranslatePipe } from '@ngx-translate/core';
import {
  ActivitySectionDirective,
  IMenuWithPages,
  MenuImageComponent,
  MenusService,
  UserActivityClickTrackingDirective,
} from '@core';

@Component({
  selector: 'app-special-offer',
  templateUrl: './special-offer.component.html',
  styleUrls: ['./special-offer.component.scss'],
  imports: [
    UserActivityClickTrackingDirective,
    ActivitySectionDirective,
    MenuImageComponent,
    TranslatePipe,
  ],
  host: {
    'class': 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpecialOfferComponent {

  private readonly router = inject(Router);
  private readonly menus = inject(MenusService);

  public readonly activeMenu: WritableSignal<IMenuWithPages | undefined> = signal<IMenuWithPages | undefined>(undefined);

  public readonly specialMenus = toSignal(this.menus.getMenuForCurrentMedia().pipe(
    tap((menus) => {
      if (!menus) {
        void this.router.navigate(['/main', 'home']);
      }
      if (menus && menus.length === 1) {
        this.activeMenu.set(menus[0]);
      }
    }),
  ));

}
